export enum ToolbarTooltipDelay {
    Open = 250,
    Close = 150,
}
